import { useEffect, useState } from 'react'

/**
 * "m:ss" elapsed since `startedAt`, ticking once a second; null without a start.
 * Shared by every live run panel (deep research, OSINT, schema agent).
 */
export function useElapsedLabel(startedAt: string | null): string | null {
  const [now, setNow] = useState(() => Date.now())
  useEffect(() => {
    if (!startedAt) return
    const id = setInterval(() => setNow(Date.now()), 1000)
    return () => clearInterval(id)
  }, [startedAt])
  if (!startedAt) return null
  const seconds = Math.max(0, Math.floor((now - new Date(startedAt).getTime()) / 1000))
  const m = Math.floor(seconds / 60)
  const s = seconds % 60
  return `${m}:${String(s).padStart(2, '0')}`
}
